import { __rest } from "tslib";
import * as React from 'react';
export var FormSelectOptionGroup = function FormSelectOptionGroup(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      label = _a.label,
      props = __rest(_a, ["children", "className", "isDisabled", "label"]);

  return React.createElement("optgroup", Object.assign({}, props, {
    disabled: !!isDisabled,
    className: className,
    label: label
  }), children);
};